var map = {
	"./0.jpg": 395,
	"./1073.jpg": 776,
	"./1163.jpg": 777,
	"./1216.jpg": 778,
	"./1267.jpg": 779,
	"./216.jpg": 780,
	"./2839.jpg": 781,
	"./2840.jpg": 782,
	"./2971.jpg": 783,
	"./4279.jpg": 784,
	"./4309.jpg": 785,
	"./4379.jpg": 786,
	"./4386.jpg": 787,
	"./4399.jpg": 788,
	"./44.jpg": 789,
	"./45.jpg": 790,
	"./4590.jpg": 791,
	"./4594.jpg": 792,
	"./46.jpg": 793,
	"./4633.jpg": 794,
	"./49.jpg": 795,
	"./66.jpg": 396,
	"./76.jpg": 796,
	"./80.jpg": 797,
	"./81.jpg": 397,
	"./avetar.jpg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;